export default "__VITE_ASSET__B7RdESNF__"